














































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import {
  Currency,
  CurrencyRate,
  Quote,
  QuoteProductCategory,
  QuoteState
} from '@/models';

import { Module, ModuleBrands } from '@/models/configurator/module';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../../common/ErrorAlert.vue';
import { ExtractVue } from '@/utils/mixins';
import QuoteProductCustomDiscountsDialog from '@/components/quotes/QuoteProductCustomDiscountsDialog.vue';

export default Vue.extend({
  components: { ErrorAlert, QuoteProductCustomDiscountsDialog },
  name: 'QuoteCategoryListItem',

  props: {
    category: {
      type: QuoteProductCategory,
      required: true
    },
    quote: {
      type: Quote,
      required: true
    }
  },

  data: () => ({
    loading: false,
    errorMessage: '',
    detailErrorMessage: ''
  }),

  computed: {
    getModuleById: get<(id: number) => Module>(
      'configuratorModule/getModuleById'
    ),

    jcmiIcon: get('app/miniCompanyImage'),
    jameswayIcon: get('app/jameswayEggIcon'),
    airwayIcon: get('app/airwayIcon'),
    chickmasterIcon: get('app/chickmasterEggIcon'),
    getCurrencyById: get<(id: number) => CurrencyRate>(
      'currency/getCurrencyById'
    ),

    exchangeRate(): number {
      return this.quote.exchange_rate!;
    },

    snapshot(): number | undefined {
      return this.quote.customer?.contract?.snapshot;
    },

    currency(): string {
      if (this.quote.currency) {
        if (
          this.getCurrencyById(this.quote.currency) &&
          this.getCurrencyById(this.quote.currency).currency
        ) {
          return (this.getCurrencyById(this.quote.currency)
            .currency as Currency)?.code;
        }
      }
      return 'CAD';
    },

    currentModule(): Module {
      return this.getModuleById(Number(this.category.module));
    },

    errorOccurred(): boolean {
      return this.errorMessage.length > 0;
    },

    configurationName(): string {
      if (!this.currentModule) {
        return this.tryGetOrFetchModule().name!;
      }
      return this.currentModule!.name ?? '';
    },

    configurationIcon(): string {
      if (this.category) {
        let brand = ModuleBrands.MODULE_BRAND_NONE;

        if (!this.currentModule) {
          this.tryGetOrFetchModule();
        }
        brand = this.currentModule.brand!;
        if (brand == ModuleBrands.MODULE_BRAND_JAMESWAY) {
          return this.jameswayIcon;
        } else if (brand == ModuleBrands.MODULE_BRAND_CHICKMASTER) {
          return this.chickmasterIcon;
        } else if (brand == ModuleBrands.MODULE_BRAND_AIRWAY) {
          return this.airwayIcon;
        }
      }
      return this.jcmiIcon;
    },
    isOnlyUnitCost(): boolean {
      return this.quote.state >= QuoteState.APPROVED;
    }
  },

  mounted() {
    this.tryGetOrFetchModule();
  },

  methods: {
    ...mapActions({
      fetchModule: 'configuratorModule/fetchModule',
      fetchCurrency: 'currency/fetchCurrency'
    }),

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    tryGetOrFetchModule() {
      if (!this.currentModule) {
        this.clearAllErrors();
        this.loading = true;
        this.fetchModule(this.category.module)
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
      return this.currentModule;
    },

    async tryGetOrFetchCurrency() {
      if (!this.getCurrencyById(this.quote.currency!)) {
        await this.fetchCurrency(this.quote.currency);
        return this.currency;
      }
      return this.currency;
    },

    async openCustomItemDialog() {
      // fetch data that is requierd for inner components

      const productCustomDiscountsDialog = this.$refs
        .quoteProductCustomDiscountsDialog as ExtractVue<
        typeof QuoteProductCustomDiscountsDialog
      >;
      productCustomDiscountsDialog.open(
        this.category,
        this.exchangeRate,
        await this.tryGetOrFetchCurrency(),
        this.snapshot
      );
    }
  }
});
